import { createSlice } from "@reduxjs/toolkit";

const otpGTMSlice = createSlice({
  name: "otpGTM",
  initialState: {
    loading: false,
    error: false,
    otpGTM: {},
    toUserInfo: {},
  },
  reducers: {
    transactionGTMDetailUpdate: (state, action) => {
      const { transferId, tokens, email, displayName, name } = action.payload;
      state.loading = false;
      state.error = false;
      state.otpGTM = { transferId, tokens, email, displayName, name };
    },
    updateToUserInfo: (state, action) => {
      const { toUserId, name, email, maskedEmail } = action.payload;
      state.toUserInfo = { toUserId, name, email, maskedEmail };
    },
  },
});

export const { transactionGTMDetailUpdate, updateToUserInfo } =
  otpGTMSlice.actions;

export default otpGTMSlice.reducer;
